export default "__VITE_ASSET__DynKZq2M__"